var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.556 10.735 15.5 12.37a.967.967 0 0 1 .438 1.185c-.844 2.306-3.312 3.524-5.639 2.674C5.537 14.49 2.01 10.962.271 6.199-.579 3.877.64 1.403 2.945.559a.971.971 0 0 1 1.185.443l1.634 2.94a1.21 1.21 0 0 1-.151 1.402c-.459.516-.917 1.03-1.375 1.542.974 2.382 2.993 4.4 5.374 5.38.516-.458 1.03-.916 1.542-1.374a1.202 1.202 0 0 1 1.402-.157Z",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;